export enum UserCourseActionTypes {
    LIST_REQUEST = '@@UserCourse/LIST_REQUEST',
    LIST_SUCCESS = '@@UserCourse/LIST_SUCCESS',
    LIST_ERROR = '@@UserCourse/LIST_ERROR',
    LIST_CLEAR = '@@UserCourse/LIST_CLEAR',

    SELECT = '@@UserCourse/SELECT',
    SELECTED = '@@UserCourse/SELECTED',
    CLEAR_SELECTED = '@@UserCourse/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@UserCourse/CREATE_REQUEST',
    CREATE_SUCCESS = '@@UserCourse/CREATE_SUCCESS',
    CREATE_ERROR = '@@UserCourse/CREATE_ERROR',
    
    READ_REQUEST = '@@UserCourse/READ_REQUEST',
    READ_SUCCESS = '@@UserCourse/READ_SUCCESS',
    READ_ERROR = '@@UserCourse/READ_ERROR',

    UPDATE_REQUEST = '@@UserCourse/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@UserCourse/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@UserCourse/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@UserCourse/DELETE_REQUEST',
    DELETE_SUCCESS = '@@UserCourse/DELETE_SUCCESS',
    DELETE_ERROR = '@@UserCourse/DELETE_ERROR',
    
    DOWNLOAD_REQUEST = '@@UserCourse/DOWNLOAD_REQUEST',
    DOWNLOAD_SUCCESS = '@@UserCourse/DOWNLOAD_SUCCESS',
    DOWNLOAD_ERROR = '@@UserCourse/DOWNLOAD_ERROR',
}

export interface UserCourseUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
    readonly downloading: boolean
    readonly downloadURL : string
}
